import { render } from "./SettingsPage.vue?vue&type=template&id=3844743c&scoped=true"
import script from "./SettingsPage.vue?vue&type=script&lang=js"
export * from "./SettingsPage.vue?vue&type=script&lang=js"

import "../css/views/SettingsPage.css?vue&type=style&index=0&id=3844743c&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3844743c"]])

export default __exports__